import { routes } from '../models/routes.enum'

export const getCurrentRoute = () => {
  let path = window.location.pathname.toUpperCase()
  path = path.replaceAll('/', '')
  path = path.replaceAll('-', '_')
  if (path.substring(0, 6) === 'CURSOS') path = 'CURSOS'
  return routes[path] ? routes[path] : routes.HOME
}
